import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, Router, UrlTree } from "@angular/router";
import { KeycloakAuthService } from "../auth/keycloak.service";
import { Roles } from "../models/roles";

export const RoleGuard: (route: ActivatedRouteSnapshot) => boolean | UrlTree = (route) => {
    const router = inject(Router);
    const authService = inject(KeycloakAuthService);
    const currentRole = authService.getPrimaryRole() ?? localStorage.getItem('role')?.toString() ?? "";
    const allowedRoles = route.data['roles'] as string[];

    if (!authService.isAuthenticated()) {
        void authService.login();
        return false;
    }

    if (allowedRoles.includes(currentRole)) {
        return true;
    }

    if (currentRole === Roles.operator) {
        return router.parseUrl('/dashboard');
    }

    if (currentRole === Roles.admin || currentRole === Roles.superAdmin) {
        return router.parseUrl('/home');
    }

    return router.parseUrl('/error');
}
